import defaultClient from '@/plugins/axios/defaultClient'

export default {
  postCdd(data) {
    return defaultClient.post('/kyc/cdd/', data)
  },
  postEdd(data) {
    return defaultClient.post('/kyc/edd/', data)
  },
  postMobileAuthUrl({ redirectPage }) {
    return defaultClient.post('/kyc/mobile-auth/url/', {
      redirectPage,
    })
  },
  postMobileAuthUrlResult() {
    return defaultClient.post('/kyc/mobile-auth/result/')
  },
  postVerifyResidentRegistrationCertificate(data) {
    const formData = new FormData()
    for (const k in data) {
      formData.append(k, data[k])
    }
    return defaultClient.post('/kyc/verify-resident-registration-certificate/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  postVerifyDriverLicense(data) {
    const formData = new FormData()
    for (const k in data) {
      formData.append(k, data[k])
    }
    return defaultClient.post('/kyc/verify-driver-license/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
